import React from "react";
import { styled } from "@mui/material/styles";
const AuthLayoutMain = styled("div")(({ theme }) => ({
  maxWidth: "400px",
  margin: "auto",
  paddingTop: "45px",
  paddingBottom: "20px",
  "&.haveArrow": {
    maxWidth: "450px",
  },
  [theme.breakpoints.down("sm")]: {
    paddingBottom: "20px",
    paddingTop: "5px",
    maxWidth: "100%",
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    paddingBottom: "20px",
    paddingTop: "50px",
    maxWidth: "100%",
    width: "100%",
  },
}));

const AuthLayout = ({ arrow = false, children }) => {
  return (
    <AuthLayoutMain className={arrow ? "haveArrow" : ""}>
      {children}
    </AuthLayoutMain>
  );
};

export default AuthLayout;
